import Box from "ds/components/Box";

import ApiKeyGroupMappingStatusBadge from "../MappingStatusBadge";
import { CellComponentProps } from "../types";

type ApiKeyGroupMappingListItemStatusCellProps = CellComponentProps;

const ApiKeyGroupMappingListItemStatusCell = ({
  group,
}: ApiKeyGroupMappingListItemStatusCellProps) => {
  return (
    <Box>
      <ApiKeyGroupMappingStatusBadge status={group.status} />
    </Box>
  );
};

export default ApiKeyGroupMappingListItemStatusCell;
